


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master perfilAcesso] Init';
export const DESTROY_SCREEN = '[Master perfilAcesso] Destroy';

export const INIT_STATE = '[Master perfilAcesso] Init State';
export const INIT_VALUE = '[Master perfilAcesso] Init Value';
export const INIT_VALUE_SUCCESS = '[Master perfilAcesso] Init Value Success';
export const INIT_VALUE_FAIL = '[Master perfilAcesso] Init Value Fail';
export const FETCH_FIELD_POSSIBLE_VALUES =
  '[Master perfil-acesso] Fetch Field Possible Values';
export const FETCH_FIELD_POSSIBLE_VALUES_SUCCESS =
  '[Master perfil-acesso] Fetch Field Possible Values Success';
export const FETCH_FIELD_POSSIBLE_VALUES_FAIL =
  '[Master perfil-acesso] Fetch Field Possible Values Fail';

export const UPDATE_DATA = "[Master perfilAcesso] Update Data";


    export const ANTERIOR = '[Master perfilAcesso] Anterior';
export const ANTERIOR_SUCCESS = '[Master perfilAcesso] Anterior Success';
export const ANTERIOR_FAIL = '[Master perfilAcesso] Anterior Fail';


    export const PROXIMO = '[Master perfilAcesso] Proximo';
export const PROXIMO_SUCCESS = '[Master perfilAcesso] Proximo Success';
export const PROXIMO_FAIL = '[Master perfilAcesso] Proximo Fail';




export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);

  // Anterior action
export const anteriorAction = ngrxCreateAction(ANTERIOR,payload => payload);

export const anteriorSuccessAction = ngrxCreateAction(ANTERIOR_SUCCESS,payload => payload);

export const anteriorFailAction = ngrxCreateAction(ANTERIOR_FAIL, payload => payload);
  // Proximo action
export const proximoAction = ngrxCreateAction(PROXIMO,payload => payload);

export const proximoSuccessAction = ngrxCreateAction(PROXIMO_SUCCESS,payload => payload);

export const proximoFailAction = ngrxCreateAction(PROXIMO_FAIL, payload => payload);



        

export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);
export const fetchFieldPossibleValuesAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES,payload => payload);
export const fetchFieldPossibleValuesSuccessAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_SUCCESS,payload => payload);
export const fetchFieldPossibleValuesFailAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_FAIL,payload => payload);


                            


export const updateDataAction = ngrxCreateAction(
  UPDATE_DATA,
  payload => payload
);

